<template>
  <div class="p-4">
    <div class="mb-base">
        <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2">
              <div class="mb-base">
                <h4 class="mb-3">Manage Funds</h4>
                <p>Add, view and manage your funds for GetBoarded</p>
              </div>
                <vx-card class="available-balance" no-shadow card-background="#FFFFFF">
                    <p class="mb-base">Funds Available</p>
                    <h1>€{{ availableFunds ? availableFunds.toFixed(2) : 0 }}</h1>
                </vx-card>
            </div>
            <div class="vx-col w-full lg:w-1/2">
                <vx-card no-shadow card-background="#F8F8F8">
                  <add-funds />
                </vx-card>
            </div>
        </div>
    </div>
    <div>
      <vs-table max-items="5" pagination :data="transactions">
        <template slot="thead">
          <vs-th> Reference Id </vs-th>
          <vs-th> Amount </vs-th>
          <vs-th> Fund Type </vs-th>
          <vs-th> Date </vs-th>
          <vs-th> Remark </vs-th>
          <vs-th> Status </vs-th>
          <vs-th> Details </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].referenceId">
              {{ data[indextr].referenceId }}
            </vs-td>

            <vs-td v-if="data[indextr].amount">
              €{{ data[indextr].amount }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].fundType">
              {{ data[indextr].fundType.toUpperCase() }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].createdAt">
              {{ data[indextr].createdAt.split('T')[0] }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].fundType">
              {{ data[indextr].remark }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].status">
              {{ data[indextr].status }}
            </vs-td>
            <vs-td v-else>
            </vs-td>

            <vs-td v-if="data[indextr].details">
              <vs-button @click.stop="showTransactionDetails=false">View Details</vs-button>
              <vs-popup v-if="data[indextr].transactionType === 'BOARD_TRANSACTION'">
                <div class="vx-row">
                  <div v-if="data[indextr].details.totalPricePerUser" class="vx-col">
                    Total Price Per User
                  </div>
                  <div class="vx-col">
                    {{ data[indextr].details.totalPricePerUser }}
                  </div>
                </div>
                <div v-if="data[indextr].details.creditsRefunded" class="vx-row">
                  <div class="vx-col">
                    Number of Credits Refunded
                  </div>
                  <div class="vx-col">
                    {{ data[indextr].details.creditsRefunded }}
                  </div>
                </div>
              </vs-popup>
            </vs-td>
            <vs-td v-else>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import AddFunds from '../components/AddFunds.vue';

export default {
  data() {
    return {
      showTransactionDetails: false
    }
  },
  components: {
    AddFunds
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    transactions() {
      return this.$store.state.payments.transactionHistory;
    },
    availableFunds() {
      return this.$store.state.payments.availableFunds;
    }
  },
  watch: {
    orgData(newVal) {
      if(newVal && newVal._id) {
        this.$store
          .dispatch("payments/fetchFunds", {
            organizationId: newVal._id,
          });

        this.$store.dispatch('payments/fetchAllTransactions', {
          organizationId: newVal._id
        });
      }
    }
  },
  created() {
    if(this.orgData && this.orgData._id) {
      this.$store
          .dispatch("payments/fetchFunds", {
            organizationId: this.orgData._id,
          });

      this.$store.dispatch('payments/fetchAllTransactions', {
        organizationId: this.orgData._id
      });
    }
  }
};
</script>

<style scoped>
.my-base-large {
  margin: 3rem auto 4rem auto;
}

button {
    border-radius: 8px!important;
}

.invite-btn {
  border-radius: 4px;
}

.coupon-code >>> .vs-con-input input.vs-input--input {
  text-transform: uppercase!important;
}

.vs-con-table >>> .vs-table--not-data {
  display: none!important;
}

.justify-content-end {
    justify-content: end;
}

.available-balance {
    border: 1px solid #F8F8F8;
    min-height: auto;
    height: auto;
}

.available-balance h1 {
    font-size: 37px;
    line-height: 30px;
    font-weight: bold;
}

.x-plus-amount {
  color: #FFFFFF;
  background-color: rgba(var(--vs-primary));
  border-radius: 15px;
  padding: 2px 5px;
  font-size: 12px;
}
</style>